import I18n from 'I18n';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import AddDataSourceFilterRecordsByTypes from 'automation-ui-formula-editor/fetch-object-panel/constants/AddDataSourceFilterRecordsByTypes';
import FormattedMessageWithSourceAndTargetObjectTypeNames from 'automation-ui-formula-editor/fetch-object-panel/components/FormattedMessageWithSourceAndTargetObjectTypeNames';
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectRecordBy = {
  MOST_RECENTLY_UPDATED: 'MOST_RECENTLY_UPDATED',
  MOST_RECENTLY_CREATED: 'MOST_RECENTLY_CREATED',
  FIRST_CREATED: 'FIRST_CREATED',
  MOST_RECENTLY_ASSOCIATED: 'MOST_RECENTLY_ASSOCIATED',
  FIRST_ASSOCIATED: 'FIRST_ASSOCIATED'
};
export const selectRecordByOptions = (flowObjectTypeId, objectTypeId, recordFilterType, isUngatedToMultiObjectDataSources) => {
  const options = [{
    text: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.recent-updated.title'),
    value: SelectRecordBy.MOST_RECENTLY_UPDATED,
    help: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.recent-updated.help_cob",
      objectTypeId: objectTypeId
    })
  }, {
    text: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.recent-created.title'),
    value: SelectRecordBy.MOST_RECENTLY_CREATED,
    help: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.recent-created.help_cob",
      objectTypeId: objectTypeId
    })
  }, {
    text: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.first-created.title'),
    value: SelectRecordBy.FIRST_CREATED,
    help: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.first-created.help_cob",
      objectTypeId: objectTypeId
    })
  }];
  if (isUngatedToMultiObjectDataSources && recordFilterType === AddDataSourceFilterRecordsByTypes.ASSOCIATION_LABEL) {
    options.unshift({
      text: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.all.title'),
      value: undefined,
      help: null
    });
  }
  if (recordFilterType === AddDataSourceFilterRecordsByTypes.ASSOCIATION_LABEL) {
    options.push({
      text: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.recent-associated.title'),
      value: SelectRecordBy.MOST_RECENTLY_ASSOCIATED,
      help: /*#__PURE__*/_jsx(FormattedMessageWithSourceAndTargetObjectTypeNames, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.recent-associated.help",
        sourceObjectTypeId: flowObjectTypeId,
        targetObjectTypeId: objectTypeId
      })
    }, {
      text: I18n.text('automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.first-associated.title'),
      value: SelectRecordBy.FIRST_ASSOCIATED,
      help: /*#__PURE__*/_jsx(FormattedMessageWithSourceAndTargetObjectTypeNames, {
        message: "automation-ui-formula-editor.fetch-object-panel.add-data-source.form-components.one-to-many-drop-down.options-text.first-associated.help",
        sourceObjectTypeId: flowObjectTypeId,
        targetObjectTypeId: objectTypeId
      })
    });
  }
  return options;
};